import type { ReactNode } from "react";
import Toolbar from "./Toolbar";

interface AppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Toolbar />
      <main className="app-main" style={{ flex: 1 }}>
        {children}
      </main>
    </div>
  );
}
